import { topicsData } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            当下最受关注的漫画与讨论，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#index"
              className="group flex items-center gap-3 bg-background-50 rounded-full px-5 py-3 hover:shadow-sm transition-all duration-200 cursor-pointer no-underline"
            >
              <span className={`px-2.5 py-1 rounded-full text-[11px] font-medium whitespace-nowrap ${topic.color}`}>
                {topic.tag}
              </span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                <i className="ri-fire-line text-accent-500 mr-0.5"></i>
                {topic.hot}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}